import React from 'react'
import PropTypes from 'prop-types'
import cookies from 'lib/cookies'

import Button from 'components/UI/Button'
import AuthLogic from 'components/Auth/AuthLogic'

import ErrorMessageContent from './ErrorMessageContent'

const RequireUserSwitchMessage = ({ title, description, logoutButtonText, renderAdditionalActions, switchUserEmail }) => {
    return (
        <ErrorMessageContent
            title={title}
            content={(
                description ? (
                    <p>
                        {description}
                    </p>
                ) : null
            )}
            actions={(
                <>
                    <AuthLogic>
                        {({ logout, loading, currentLocation }) => (
                            <Button
                                trackName="signOut"
                                className="button button--medium"
                                onClick={() => {
                                    if (switchUserEmail) {
                                        // set nettix-username so email will get prefilled when logging in
                                        cookies.set('nettix-username', switchUserEmail, { maxAge: 30 })
                                    }
                                    logout(currentLocation)
                                }}
                                loading={loading}
                            >
                                {logoutButtonText}
                            </Button>
                        )}
                    </AuthLogic>
                    {!!renderAdditionalActions && renderAdditionalActions}
                </>
            )}
        />
    )
}

RequireUserSwitchMessage.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    logoutButtonText: PropTypes.string.isRequired,
    renderAdditionalActions: PropTypes.node,
    switchUserEmail: PropTypes.string,
}

export default RequireUserSwitchMessage
